
import { Component, Prop, Vue } from 'vue-property-decorator';

interface ItemData {
  title: string;
  link: string;
  icon?: string;
  section: string;
  sectionTitle: string;
  groupTitle?: string;
}

@Component
export default class PinButton extends Vue {
  @Prop({ required: true })
  public isPinned!: boolean;
  
  @Prop({ required: true })
  public itemData!: ItemData;
  
  @Prop({ default: false })
  public showAlways!: boolean;
  
  get iconName(): string {
    return this.isPinned ? 'mdi-pin-off' : 'mdi-pin';
  }
  
  get iconColor(): string {
    if (this.isPinned) {
      return 'primary';
    }
    return 'grey lighten-1';
  }
  
  get tooltipText(): string {
    if (this.isPinned) {
      return 'Unpin from top';
    }
    return 'Pin to top for quick access';
  }
  
  private handleClick(): void {
    this.$emit('toggle-pin', this.itemData);
    
    // Add a small animation effect
    const button = this.$el as HTMLElement;
    button.classList.add('pin-clicked');
    setTimeout(() => {
      button.classList.remove('pin-clicked');
    }, 300);
  }
}
